
























import Vue from "vue";

interface Props {
  disabled: boolean;
  placeholder: string;
  value: string;
  wordCount: number;
}

export default Vue.extend<any, any, any, Props>({
  name: "TranslationDrillInput",

  props: {
    disabled: { type: Boolean, default: false },
    placeholder: { type: String, default: "" },
    value: { type: String, default: "" },
    wordCount: { type: Number, default: 0 }
  },

  computed: {
    negativeWordCount() {
      return this.wordCount < 0;
    }
  },
  created() {
    this.$nextTick(() => {
      this.$refs.input.focus();
    });
  },
  watch: {
    disabled: {
      handler(isDisabled) {
        if (!isDisabled) {
          this.$nextTick(() => {
            this.$refs.input.focus();
          });
        }
      }
    }
  }
});
